import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/maiscontrole-lancamentos/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/maiscontrole-lancamentos/delete`,
        endpoint: `${endpointBackend}gci/maiscontrole-lancamentos/getall`
    }

    let list = {
        labelTitle: 'Mais Controle - Lançamentos',
        fieldsShowOnDelete: ['descricao'],
        canAdd: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'id_lancamento',
                label: 'ID Lançamento'
            },
            {
                name: 'nome_obra',
                label: 'Obra',
                width: '30%'
            },
            {
                name: 'centro_de_custo',
                label: 'Centro de Custo',
                width: '20%'
            },
            {
                name: 'fornecedor',
                label: 'Fornecedor',
                width: '25%'
            },
            {
                name: 'descricao',
                label: 'Descrição',
                width: '25%'
            },
            {
                name: 'numero_documento',
                label: 'Número Documento',
                width: '15%'
            },
            {
                name: 'data_competencia',
                label: 'Data Competência'
            },
            {
                name: 'valor_total_lancamento',
                label: 'Valor Total Lançamento'
            },
            {
                name: 'conta_bancaria',
                label: 'Conta Bancária',
                width: '20%'
            },
            {
                name: 'categoria',
                label: 'Categoria',
                width: '20%'
            },
            {
                name: 'condicao_pagamento',
                label: 'Condição Pagamento',
                width: '20%'
            },
            {
                name: 'numero_parcela',
                label: 'Nº Parcela'
            },
            {
                name: 'valor_parcela',
                label: 'Valor Parcela'
            },
            {
                name: 'data_vencimento',
                label: 'Data Vencimento'
            },
            {
                name: 'indice_item_orcamento',
                label: 'Índice Item Orçamento',
                width: '15%'
            },
            {
                name: 'possui_vinculo_estoque',
                label: 'Possui Vínculo Estoque'
            },
            {
                name: 'ordem_de_compra',
                label: 'Ordem de Compra',
                width: '15%'
            },
            {
                name: 'data_lancamento',
                label: 'Data Lançamento'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                canAdd={list.canAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
